import { RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material';
import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { useControllableState } from '@radix-ui/react-use-controllable-state';
import { forwardRef } from 'react';

import {
  RadioToggleGroupContext,
  RadioToggleGroupItemContext,
  useRadioToggleGroupContext,
  useRadioToggleGroupItemContext,
} from './RadioToggleGroup.context';

export const RadioToggleGroupRoot = forwardRef<
  HTMLDivElement,
  Omit<ToggleGroup.ToggleGroupSingleProps, 'type'>
>(({ defaultValue, value, onValueChange, ...props }, ref) => {
  const [internalValue, setInternalValue] = useControllableState({
    prop: value,
    defaultProp: defaultValue ?? '',
    onChange: onValueChange,
  });

  return (
    <RadioToggleGroupContext.Provider value={{ value: internalValue }}>
      <ToggleGroup.Root
        value={internalValue}
        onValueChange={setInternalValue}
        ref={ref}
        {...props}
        type="single"
      />
    </RadioToggleGroupContext.Provider>
  );
});

export const RadioToggleGroupItem = forwardRef<
  HTMLButtonElement,
  ToggleGroup.ToggleGroupItemProps
>(({ value, ...props }, ref) => {
  const { value: contextValue } = useRadioToggleGroupContext();
  const toggledOn = contextValue === value;

  return (
    <RadioToggleGroupItemContext.Provider value={{ toggledOn }}>
      <ToggleGroup.Item value={value} ref={ref} {...props} type="button">
        {props.children}
      </ToggleGroup.Item>
    </RadioToggleGroupItemContext.Provider>
  );
});

export const RadioToggleGroupIcon = () => {
  const { toggledOn } = useRadioToggleGroupItemContext();

  if (toggledOn) {
    return (
      <RadioButtonChecked
        fontSize="inherit"
        color="inherit"
        className="text-primary-100"
      />
    );
  } else {
    return (
      <RadioButtonUnchecked
        fontSize="inherit"
        color="inherit"
        className="text-grey-80"
      />
    );
  }
};
